import { useSelector } from 'react-redux'
import Accordion from '../../../../../../UI/Accordion/Accordion'
import props from '../../../../../../../redux/props'
import { PrebuildType } from '../../../../../../../types/Survey/Element'
import { ConceptValues } from '../../../../../../../types/Survey/Analysis/Concept'
import Number from '../../../../../../UI/Input/Number'
import { PlusIcon } from '@heroicons/react/24/solid'
import { TrashIcon } from '@heroicons/react/24/outline'
import Input from '../../../../../../UI/Input/Input'
import { formatNumber } from '../../../../../../../utility'

type Props = {
  values: ConceptValues
  updateValue?: (key: any) => (value: any) => void
  pushValue: (type: PrebuildType, value: any) => void
  removeValue: (type: PrebuildType, index: number) => () => void
}

const Sonderbedarfe: React.FC<Props> = ({ values, updateValue, pushValue, removeValue }) => {
  const t = useSelector((s) => s[props.TRANSLATION])

  const add = () => {
    const newSonderbedarf = {
      name: '',
      originalPracticalQM: 0,
      practicalQM: 0,
      originalAmount: 0,
    }
    pushValue(PrebuildType.SONDERBEDARFE, newSonderbedarf)
  }

  const items = [
    {
      key: 'sonderbedarfe',
      title: t.survey.analysis.concept.sonderbedarfe.title,
      content: (
        <div>
          {values.ergebnisse.SONDERBEDARFE.length === 0 && (
            <div className="text-sm text-gray">{t.survey.analysis.calculation.values.sonderbedarfe.empty}</div>
          )}
          {values.ergebnisse.SONDERBEDARFE.length > 0 && (
            <div className="flex flex-col gap-1">
              <div className="text-sm font-bold">{t.survey.analysis.calculation.values.sonderbedarfe.managerInput}</div>
              {values.ergebnisse.SONDERBEDARFE.map((s, i) => (
                <div className="flex items-center gap-3" key={i}>
                  <div className="w-1/3 shrink-0">
                    <Input value={s.name} onChange={updateValue(`${PrebuildType.SONDERBEDARFE}.${i}.name`)} />
                  </div>
                  <div className="w-1/3">
                    <div className="text-sm">{`${t.survey.analysis.calculation.values.originalValuePrefix}${s.originalPracticalQM}${t.generic.squareMeterSuffix}`}</div>
                    <div className="text-sm">
                      {`${t.survey.analysis.calculation.values.originalValuePrefix}${formatNumber(s.originalAmount)}${t.generic.amountSuffix}`}
                    </div>
                  </div>
                  <div className="w-1/3">
                    <Number
                      value={s.practicalQM}
                      onChange={updateValue(`${PrebuildType.SONDERBEDARFE}.${i}.practicalQM`)}
                      suffix={t.generic.squareMeterSuffix}
                      decimal
                    />
                  </div>
                  <div
                    className="w-6 aspect-square bg-red-500 rounded-full flex items-center justify-center text-white cursor-pointer"
                    onClick={removeValue(PrebuildType.SONDERBEDARFE, i)}
                  >
                    <TrashIcon className="stroke-blue hover:stroke-red w-5" />
                  </div>
                </div>
              ))}
            </div>
          )}
          <div className="flex gap-3 justify-end mt-3">
            <div onClick={add} className="w-6 aspect-square bg-cyan rounded-full flex items-center justify-center text-white cursor-pointer">
              <PlusIcon className="fill-white w-5" />
            </div>
          </div>

          <div className="flex flex-col gap-1 mt-0">
            <div className="text-sm font-bold">{t.survey.analysis.calculation.values.sonderbedarfe.baseAssumption}</div>
            {['drucker', 'locker', 'workcafe', 'garderobe'].map((s) => (
              <div className="flex items-center gap-3" key={s}>
                <div className="w-1/3 shrink-0">{t.survey.analysis.calculation.values[s].headline}</div>
                <div className="w-1/3">
                  <div>
                    {`${t.survey.analysis.calculation.values.originalValuePrefix}${formatNumber(values[s].originalPracticalQM)}${
                      t.generic.squareMeterSuffix
                    }`}
                  </div>
                </div>
                <div className="w-1/3">
                  <Number value={values[s].practicalQM} onChange={updateValue(`${s}.practicalQM`)} suffix={t.generic.squareMeterSuffix} decimal />
                </div>
                <div className="w-6 aspect-square bg-red-500 rounded-full flex items-center justify-center text-white cursor-pointer"></div>
              </div>
            ))}
          </div>
        </div>
      ),
    },
  ]

  return (
    <div className="mt-3">
      <Accordion items={items} invert />
    </div>
  )
}

export default Sonderbedarfe
